











































import { Vue, Component } from "vue-property-decorator";
import { namespace } from "vuex-class";

const Auth = namespace("auth");

@Component({})
export default class Verify extends Vue {
  @Auth.Action("resendEmail") resendEmail!: (email: string) => Promise<{}>;
  @Auth.Getter("getVerificationEmail") verifcationEmail: string;

  canSendResendEmail = true;
  timeout = 30000;
  hasError = false;
  loading = false;

  resendConfirmationEmail() {
    const email = this.verifcationEmail;
    this.loading = true;
    this.resendEmail(email)
      .then(() => {
        this.canSendResendEmail = false;
        this.loading = false;
        setInterval(() => {
          this.canSendResendEmail = true;
        }, this.timeout);
      })
      .catch(() => {
        this.loading = false;
        this.hasError = true;
      });
  }
}
